export default "__VITE_PUBLIC_ASSET__8387bc6d__"